import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Alert,
} from '@mui/material';

interface RequestBodyEditorProps {
  requestBody: string;
  onRequestBodyChange: (body: string) => void;
  disabled?: boolean;
}

export const RequestBodyEditor: React.FC<RequestBodyEditorProps> = ({
  requestBody,
  onRequestBodyChange,
  disabled = false,
}) => {
  // Validate JSON
  const isValidJson = () => {
    if (!requestBody.trim()) return true; // Empty is valid
    try {
      JSON.parse(requestBody);
      return true;
    } catch {
      return false;
    }
  };

  const isValid = isValidJson();

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Request Body
      </Typography>
      
      {!isValid && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Invalid JSON format. Please check your syntax.
        </Alert>
      )}
      
      <TextField
        fullWidth
        multiline
        rows={8}
        value={requestBody}
        onChange={(e) => onRequestBodyChange(e.target.value)}
        placeholder="Enter JSON request body..."
        disabled={disabled}
        variant="outlined"
        error={!isValid}
        helperText={isValid ? "Enter valid JSON for the request body" : "Invalid JSON syntax"}
        sx={{
          '& .MuiInputBase-input': {
            fontFamily: 'monospace',
            fontSize: '0.875rem',
          },
        }}
      />
    </Box>
  );
};